import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, FormGroup, Label, Input, Badge } from 'reactstrap';
import WebapiCommon from '@common/util/webapi.common';
import { useIntl } from 'react-intl';
import IntlMessage from '../../../../../helpers/intlMessage';
import { useDispatch, useSelector } from 'react-redux';
import * as commonActions from '@common/common.action';
const LaudoAgrupadoModal = (props) => {
    const [laudos, setLaudos] = useState(null);
    const [laudosSelecionados, setLaudosSelecionados] = useState([]);
    const [laudo, setLaudo] = useState(null);
    const [pedido, setPedido] = useState(null);
    const [acNumber, setAcNumber] = useState(null);
    const [atendimento, setAtendimento] = useState(null);
    const [paciente, setPaciente] = useState('');
    const [data, setData] = useState('');
    const [solicitante, setSolicitante] = useState('');
    const [exame, setExame] = useState('');
    const [nrExame, setNrExame] = useState(null);

    const dt = useRef();
    const { messages } = useIntl();
    const dispatch = useDispatch();

    useEffect(() => {
        if(props.isOpen){
            dispatch(commonActions.showFadeCarregando(true))
                WebapiCommon.obterDadoslaudoAgrupado(props.laudo).then((response) => {
                    setLaudo(response.laudo);
                    setPaciente(response.paciente);
                    setPedido(response.pedido);
                    setAcNumber(response.acNumber);
                    setAtendimento(response.atendimento);
                    setData(response.data);
                    setSolicitante(response.solicitante);
                    setExame(response.exame);
                    setNrExame(response.nrExame);

                    setLaudosSelecionados(response.nrExame? []: {});

                    WebapiCommon.obterDadoslaudoAgrupadoPedido(props.laudo, response.pedido).then((dados) => {
                        setLaudos(dados);
                        dispatch(commonActions.showFadeCarregando(false))
                    })
                })
        }
    }, [props.isOpen]);

    const handleSubmit = () => {
        dispatch(commonActions.showFadeCarregando(true));

        var body = {};

        if (nrExame && nrExame!= null){
            body = {
                laudosSelecionados: laudosSelecionados.map((x) => x.laudo),
                laudo: laudo
            };
        }
        else {
            body = {
                laudosSelecionados: [laudo],
                laudo: laudosSelecionados.laudo
            }
        }

        WebapiCommon.AgruparLaudos(body).then((response) => {
            if (response) {
                dispatch(commonActions.showAlerta('alerta', messages['messages.obito.updateSucess'], '3000'));

                laudosSelecionados.forEach(x => {
                    WebapiCommon.getDetalhes(x.laudo).then((detalhes) => {
                        dispatch(commonActions.atualizarDetalhes(detalhes));
                        dispatch(commonActions.atualizarNumeroExameDoLaudoNaListagem(detalhes.laudo, detalhes.nrExame));
                    });

                    WebapiCommon.obterStatusEtapasLaudo(x.laudo).then((etapas) => {
                        dispatch(commonActions.atualizarStatusDasEtapasDoLaudo(etapas, x.laudo));
                    });
                });

                WebapiCommon.getDetalhes(props.laudo).then((detalhes) => {
                    dispatch(commonActions.atualizarDetalhes(detalhes));
                    dispatch(commonActions.atualizarNumeroExameDoLaudoNaListagem(detalhes.laudo, detalhes.nrExame));
                });

                WebapiCommon.obterStatusEtapasLaudo(props.laudo).then((etapas) => {
                    dispatch(commonActions.atualizarStatusDasEtapasDoLaudo(etapas, props.laudo));
                });
            }
        })
        dispatch(commonActions.showFadeCarregando(false));
        setLaudosSelecionados([]);
        props.setOpenModalLaudoAgrupado(false);
    };

    return (
            <Modal size='xl' isOpen={props.isOpen} toggle={() => props.setOpenModalLaudoAgrupado(!props.isOpen)} backdrop="static">
                <ModalHeader>
                    <IntlMessage id="dashboard.groupExams.modal.title" />
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col xl={3}>
                            <FormGroup>
                                <Label>
                                    <IntlMessage id="dashboards.general.report" />
                                </Label>
                                <Input type="text" value={laudo} readOnly></Input>
                            </FormGroup>
                        </Col>
                        <Col xl={3}>
                            <FormGroup>
                                <Label>
                                    <IntlMessage id="dashboards.examDetails.request" />
                                </Label>
                                <Input type="text" value={pedido} readOnly></Input>
                            </FormGroup>
                        </Col>
                        <Col xl={3}>
                            <FormGroup>
                                <Label>
                                    <IntlMessage id="Ac number" />
                                </Label>
                                <Input type="text" value={acNumber} readOnly></Input>
                            </FormGroup>
                        </Col>
                        <Col xl={3}>
                            <FormGroup>
                                <Label>
                                    <IntlMessage id="dashboards.general.attendance" />
                                </Label>
                                <Input type="text" value={atendimento} readOnly></Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={9}>
                            <FormGroup>
                                <Label>
                                    <IntlMessage id="dashboards.general.pacient" />
                                </Label>
                                <Input type="text" value={paciente} readOnly></Input>
                            </FormGroup>
                        </Col>
                        <Col xl={3}>
                            <FormGroup>
                                <Label>
                                    <IntlMessage id="protocol.date" />
                                </Label>
                                <Input type="text" value={data} readOnly></Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12}>
                            <FormGroup>
                                <Label>
                                    <IntlMessage id="dashboards.examDetail.table.exam" />
                                </Label>
                                <Input type="text" value={exame} readOnly></Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12}>
                            <FormGroup>
                                <Label>
                                    <IntlMessage id="dashboards.examDetail.doctorRequesting" />
                                </Label>
                                <Input type="text" value={solicitante} readOnly></Input>
                            </FormGroup>
                        </Col>
                    </Row>
            <div
                className="vivace-datatable"
                style={{ maxHeight: 'calc(100vh - 245px)', overflowY: 'auto' }}
            >
                <DataTable
                    id='testerafael'
                    ref={dt}
                    value={laudos}
                    responsive
                    className="p-datatable-customers"
                    dataKey="laudo"
                    rowHover
                    selection={laudosSelecionados}
                    onSelectionChange={(e) =>{setLaudosSelecionados(e.value)}}
                    emptyMessage={messages['messages.notdata']}
                    scrollHeight='400px'
                    scrollable={true}
                >
                   <Column id={'laudo_'+laudo} selectionMode={nrExame?"multiple": "single"} style={{ width: '4em' } } />

                    <Column
                        field="laudo"
                        header={messages["dashboards.general.report"]}
                        sortable
                    ></Column>
                        <Column
                        field="nrExame"
                        header={messages["dashboards.examDetail.table.exam"]}
                        sortable
                    ></Column>
                    <Column
                        field="acNumber"
                        header="AC Number"
                        sortable
                    ></Column>
                    <Column
                        field="data"
                        header={messages["protocol.date"]}
                        sortable
                    ></Column>
                    <Column
                        field="paciente"
                        header={messages["dashboards.taskControl.patient"]}
                        sortable
                    ></Column>
                    <Column
                    >
                    </Column>
                </DataTable>
            </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="primary"
                    onClick={() => handleSubmit()}
                    disabled={!laudosSelecionados ||
                        laudosSelecionados.length === 0}
                >
                    <IntlMessage id="general.materialArchiving.save" />
                </Button>
                <Button
                    color="secondary"
                    onClick={() => {
                        setLaudosSelecionados([]);
                        props.setOpenModalLaudoAgrupado(false);
                    }}
                >
                    <IntlMessage id="general.materialArchiving.close" />
                </Button>
            </ModalFooter>
            </Modal>
    );
};

export default LaudoAgrupadoModal;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/modal/laudoagrupado.modal.js